/**
 * @fileOverview
 * Defines all backend API endpoint paths used throughout the application.
 * These paths are grouped by feature areas like file operations, study, and panel information.
 */
export const apiPaths = {
  fileOperations: {
    upload: `instrumentIO/upload/instrumentcsv/`,
    refUpload: `referenceIO/upload/referencedata/`,
    refDelete: `referenceIO/delete/`,
    instrumentDelete: `instrumentIO/delete/`,
    importCalLot: 'referenceIO/CoA/CalibratorCofA/',
    importQcLot: 'referenceIO/CoA/ControlCofA/'
  },
  panelInfo: {
    panels: 'referenceIO/panelinfo/',
    panelSpecs: 'referenceIO/panelspecs/',
    getFiles: 'referenceIO/getReferenceFileInfo',
    auditTrail: 'referenceIO/auditTrail',
    qcLots: `controlLots`,
    calLots: `calLots`,
  },
  study: {
    commitStudy: 'studies/commit/',
    studyList: 'studies/display/',
    calculate: 'calculations/calc/',
    pullSampleData: 'calculations/pull_sample_data/',
    getCalculateCsv: 'calculations/calc_get_csv/',
    save: 'studies/save/',
    saveDraft: 'studies/save_draft/',
    load: 'studies/load/',
    loadDraft: 'studies/load_draft/',
    // A Calibrator Match Kit study's measured regression and qualitative sample columns, for a
    // Control Match Kit C of A to state — that run measures neither for itself. A plain GET with a
    // `run_name` query parameter, not a polled job.
    exportRegressionStats: 'studies/export_regression_stats/',
    delete: 'studies/delete/',
    pollCalculationStatus: 'calculations/polling_status/',
    auditTrail: 'studies/audit_trail/',
    // Cross-study rollup backing the Studies logbook — every saved study, not one run's contents.
    logbook: 'studies/logbook/',
    // Every linkage between studies in one payload, and the two standalone edits. Separate from
    // `related_study_names` on a save, which replaces one study's whole set and needs the study
    // loaded; the Studies screen edits one pair at a time with neither study in hand.
    links: 'studies/links/',
    addLink: 'studies/links/add/',
    removeLink: 'studies/links/remove/',
  },
  reports: {
    exportReport: 'reports/export_report/',
  },
  users: {
    getUserInfo: 'users/getUserInfo',
    createUser: 'users/upsert_user',
    deactivateUser: 'users/deactivateUser'
  },
  login: 'users/sign_in',
  instrumentMappings: 'instrumentMappings/',
  // Admin-set default "Allowed adjustment factor (%)" per panel and workflow. GET is open to any
  // authenticated user (the Adjusted Calibrator screen reads it); PUT/DELETE are super-user only.
  calibrationAdministration: 'calibrationAdministration/',
}
